import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PbiManagerMfeComponent } from './pbi-manager-mfe/pbi-manager-mfe.component';

export const routes: Routes = [
  {
    path: '',
    component: PbiManagerMfeComponent,
    data: {
      isMfe: true,
      module: 'special-dashboards',
      hideBreadcrumbs: true,
      hideModuleTitle: true,
      reuse: true
    },
    children: [
      {
        path: '**',
        component: PbiManagerMfeComponent,
        data: {
          isMfe: true,
          module: 'special-dashboards',
          hideBreadcrumbs: true,
          hideModuleTitle: true,
          reuse: true
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PbiManagerMfeRoutingModule { }
